var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.src ? _c('div', {
    directives: [{
      name: "el-resize",
      rawName: "v-el-resize",
      value: _vm.scale ? null : _vm.debouncedOnResize,
      expression: "scale ? null : debouncedOnResize"
    }],
    staticClass: "absolute-fill card-background",
    class: {
      loaded: _vm.loaded
    }
  }, [!_vm.src.endsWith('.mp4') ? _c('img', {
    staticClass: "absolute-fill",
    attrs: {
      "width": "100%",
      "height": "100%",
      "loading": "lazy",
      "src": _vm.src
    },
    on: {
      "load": function ($event) {
        _vm.loaded = true;
      }
    }
  }) : _vm.scaled ? [_vm.tryVideo ? _c('video', {
    ref: "video",
    staticClass: "absolute-fill",
    attrs: {
      "width": "100%",
      "height": "100%",
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "loading": "lazy",
      "poster": _vm.poster,
      "src": _vm.scaled.src
    },
    domProps: {
      "muted": true
    },
    on: {
      "loadeddata": function ($event) {
        _vm.loaded = true;
      }
    }
  }) : _c('picture', [_c('source', {
    attrs: {
      "type": "video/mp4",
      "srcset": _vm.scaled.src
    }
  }), _c('img', {
    staticClass: "absolute-fill",
    attrs: {
      "width": "100%",
      "height": "100%",
      "type": "image/jpeg",
      "loading": "lazy",
      "src": _vm.poster
    },
    on: {
      "load": function ($event) {
        _vm.loaded = true;
      }
    }
  })])] : _vm._e()], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }